/* eslint-disable react/destructuring-assignment */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { currency } from '@carvana/purchase-utils';

const Wrapper = styled.div``;

const SliderContainer = styled.div`
  width: 100%;

  [type='range']::-ms-thumb {
    margin-top: 0;
    box-sizing: border-box;
    width: 2em;
    height: 2em;
    border-radius: 50%;
    background: #fff;
    border: 3px solid ${props => props.theme.carvana.blue};
  }
`;

const SliderThumb = css`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #fff;
  border: 3px solid ${props => props.theme.carvana.blue};
  cursor: grab;
  z-index: 10;

  &:active {
    cursor: grabbing;
  }
`;

const Slider = styled.input.attrs({ type: 'range' })`
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  position: relative;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    background: transparent;
    height: 1.8rem;
  }

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    ${SliderThumb};

    /* &::before {
      background-color: red;
    } */
  }

  &::-webkit-slider-runnable-track {
    /* height: 7px; */
    /* background: red;
    content: '';
    */
    /* pointer-events: none; */
    /* width: 300px; */
    /* height: 5px;
    background: red;
    border: none;
    border-radius: 3px; */
  }

  &::-moz-range-thumb {
    ${SliderThumb};
  }

  /* &::-webkit-progress-value {
    background-color: orange;
  } */

  &::-moz-range-track {
    /* common styles */
  }

  &::-moz-focus-outer {
    border: 0;
  }

  &::-ms-track {
    color: transparent;
    background: #d3d3d3;
    border-radius: 5px;
    background-color: #d3d3d3;
  }

  &::-ms-ticks-after {
    display: none;
  }

  &::-ms-ticks-before {
    display: none;
  }

  &::-ms-fill-lower {
    background: transparent;
  }

  &::-ms-fill-upper {
    background: transparent;
  }

  &::-ms-thumb {
    ${SliderThumb};
    margin-top: 0;
    box-sizing: border-box;
    width: 2em;
    height: 2em;
    border-radius: 50%;
    background: #fff;
    border: 3px solid ${props => props.theme.carvana.blue};
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 1.5rem;
`;

const ContentLeft = styled.div`
  font-weight: 700;
  font-size: 1rem;
`;

const ContentRight = styled.div`
  font-size: 1.5rem;
  color: ${props => props.theme.carvana.grayFour};
  font-weight: 300;
`;

const SliderValuesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 1rem;
`;

const SliderValues = styled.div`
  font-size: 1.2rem;
  color: ${props => props.theme.carvana.grayFour};
`;

class TermSliders extends PureComponent {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    formatAsCurrency: PropTypes.bool,
    useLocalState: PropTypes.bool
  };

  static defaultProps = {
    value: 0,
    min: 0,
    max: 100,
    step: 1,
    formatAsCurrency: true,
    useLocalState: true
  };

  inputRef = React.createRef();

  state = {
    value: this.props.value,
    min: this.props.min,
    max: this.props.max,
    step: this.props.step
  };

  // add more events for capturing
  componentDidMount() {
    this.inputRef.current.addEventListener('touchend', this.onSelect);
    this.inputRef.current.addEventListener('keyup', this.onKeyChange); // should only be for arrows
  }

  componentDidUpdate(prevProps) {
    const { min, max, value, step } = this.props;
    if (
      min !== prevProps.min ||
      max !== prevProps.max ||
      value !== prevProps.value ||
      step !== prevProps.step
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        min,
        max,
        value,
        step
      });
    }
  }

  componentWillUnmount() {
    this.inputRef.current.removeEventListener('touchend', this.onSelect);
    this.inputRef.current.removeEventListener('keyup', this.onKeyChange);
  }

  onChange = e => {
    e.persist();
    const { onChange } = this.props;
    const { value } = e.target;
    this.setState({ value });
    if (onChange) onChange(e.target);
  };

  onKeyChange = e => {
    if (
      e.key === 'ArrowLeft' ||
      e.key === 'ArrowRight' ||
      e.key === 'ArrowUp' ||
      e.key === 'ArrowDown'
    ) {
      const { onSelect } = this.props;
      if (onSelect) onSelect(e.target);
    }
  };

  onSelect = e => {
    const { onSelect } = this.props;
    if (onSelect) onSelect(e.target);
  };

  render() {
    const { label, name, formatAsCurrency, value, useLocalState } = this.props;
    const { min, max, step } = this.state;

    return (
      <Wrapper>
        <Content>
          <ContentLeft>{label}</ContentLeft>
          <ContentRight data-cv-test={`selected${name}`}>
            {formatAsCurrency
              ? currency(value, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })
              : value}
          </ContentRight>
        </Content>

        <SliderValuesWrapper>
          <SliderValues>
            {formatAsCurrency
              ? currency(min, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })
              : min}
          </SliderValues>

          <SliderValues>
            {formatAsCurrency
              ? currency(max, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })
              : max}
          </SliderValues>
        </SliderValuesWrapper>

        <SliderContainer>
          <Slider
            ref={this.inputRef}
            type="range"
            min={min}
            max={max}
            value={useLocalState ? this.state.value : this.props.value}
            step={step}
            // step={
            //   Number.parseInt(value, 10) + Number.parseInt(step, 10) > max
            //     ? 1
            //     : step
            // }
            id={name}
            name={name}
            onClick={this.onSelect}
            onChange={this.onChange}
            data-cv-test={`${name}Slider`}
            style={{
              background: `linear-gradient(#00aed9, #00aed9) 0 / calc(.5*2rem + calc((${value} - ${min})/calc(${max} - ${min}))*(100% - 2rem)) 100% no-repeat #d3d3d3`
            }}
          />
        </SliderContainer>
      </Wrapper>
    );
  }
}

export default TermSliders;
